<template>
  <v-layout column>
    <h3 class="subheading-2 db--text">
      <v-icon color="db" class="mr-4">mdi-school</v-icon>Bonjour French Classroom
    </h3>
    <p class="mt-4 mb-0">Welcome to Bonjour French Classroom Application</p>
    <p>You can find exciting exercises and olympiads to level up your French Skills plus Helpful resources to download.</p>
    <p class="mt-4">
      If you have any queries contact us at
      vicky.tuteja1991@gmail.com or
      +91 9811428849
    </p>
    <h4 class="subheading-2 db--text mt-5">Schools linked with us</h4>
    <v-layout class="mt-4" row wrap>
      <v-flex
        lg2
        xs12
        v-for="school in getSchools"
        :key="school.schoolName"
        class="card-shd school-container"
      >
        <a :href="school.url" target="_blank">
          <img class="school" :src="school.imgUrl" :alt="school.schoolName">
        </a>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Schools",
  computed: {
    ...mapGetters(["getSchools"])
  }
};
</script>

<style>
.card-shd {
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.1) !important;
}

.school-container {
  position: relative;
  width: 150px;
  height: 150px;
  margin: 15px;
  box-sizing: border-box;
}

.school {
  padding: 20px;
  max-width: 150px;
  max-height: 150px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
